export default "__VITE_ASSET__2YrOtcYm__"